import { render, staticRenderFns } from "./terms-conditions-tabs-modal.vue?vue&type=template&id=6cdb89dd&scoped=true"
import script from "./terms-conditions-tabs-modal.vue?vue&type=script&lang=js"
export * from "./terms-conditions-tabs-modal.vue?vue&type=script&lang=js"
import style0 from "./terms-conditions-tabs-modal.vue?vue&type=style&index=0&id=6cdb89dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdb89dd",
  null
  
)

export default component.exports